// eslint-disable-next-line no-restricted-imports
import { Theme, useTheme as useMuiTheme } from "@mui/material/styles";

export const useTheme = () => useMuiTheme<Theme>();
